"use client";

import { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";
import { usePathname, useSearchParams } from "next/navigation";

import { Button } from "@/components/ui/button";
import { ExamChatbot } from "@/components/exam-chatbot";
import { useAuth } from "@/context/auth-context";

export function ChatbotFloatingButton() {
  const [isOpen, setIsOpen] = useState(false);
  const { isAuthenticated } = useAuth();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  // Lynx session uses the same corner — this fixed z-50 button paints above <main> and hid the composer.
  const hideOnStudentLynx = pathname === "/student" && searchParams.get("tab") === "lynx";
  const hideOnMessages = pathname === "/messages" || Boolean(pathname?.startsWith("/messages/"));

  useEffect(() => {
    const handler = () => setIsOpen((prev) => !prev);
    window.addEventListener("toggle-chatbot", handler);
    return () => window.removeEventListener("toggle-chatbot", handler);
  }, []);

  if (hideOnStudentLynx || hideOnMessages) return null;

  return (
    <>
      <Button
        onClick={() => setIsOpen(!isOpen)}
        className="flex fixed bottom-6 right-4 sm:right-6 h-11 w-11 rounded-full shadow-lg z-50 print:hidden"
        data-print-hide
        size="icon"
        aria-label={isOpen ? "Close chat" : "Open chat"}
      >
        {isOpen ? <X className="h-5 w-5" /> : <MessageCircle className="h-5 w-5" />}
      </Button>

      {isOpen && (
        <div className="fixed bottom-[4.5rem] right-0 left-0 sm:left-auto sm:right-6 sm:w-96 w-full max-w-full sm:max-w-[calc(100vw-2rem)] z-40 shadow-2xl px-3 pb-2 sm:px-0 sm:pb-0 print:hidden" data-print-hide>
          <ExamChatbot onClose={() => setIsOpen(false)} />
        </div>
      )}
    </>
  );
}
